// import React from "react";
// import { menus } from "../Data";
// import { Box, Typography } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";

// export default function Menu() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   return (
//     <Box
//       columnGap="20px"
//       sx={{ display: { md: "flex", xs: "none" }, flexDirection: "row" }}
//     >
//       {menus?.map((item, index) => {
//         const isActive = location.pathname === item?.uri_link;
//         return (
//           <>
//             <Box
//               key={index}
//               onClick={() => navigate(item?.uri_link)}
//               mt="20px"
//               pt={3}
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 width: { lg: 90, md: 70, sm: 60 },
//                 height: "100px",
//                 borderBottom: isActive ? "3px solid white" : "none",
//                 "&:hover": {
//                   borderBottom: "3px solid white",
//                   transition: "0.2s",
//                 },
//                 cursor: "pointer",
//               }}
//             >
//               <Box display="flex" justifyContent="center">
//                 <Box component="img" src={item?.icon}></Box>
//               </Box>
//               <Typography
//                 textAlign="center"
//                 mt="10px"
//                 variant="h9_3"
//                 color="white"
//               >
//                 {item?.nav_bar_name}
//               </Typography>
//             </Box>
//           </>
//         );
//       })}
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { menus } from "../Data";
import { Box, Typography, Drawer, Menu,IconButton, Button, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../Icons/logo.svg";
import CloseIcon from '@mui/icons-material/Close';
import { DocumentTitleChange } from "../CommonComponents/Title";
import LinksIcon from "../Icons/Menus/links.svg";
import NewsIcon from "../Icons/Menus/news.svg";
import VisitorIcon from "../Icons/Menus/visitor.svg";
import ServicesIcon from "../Icons/Menus/services.svg";
import ApplicationIcon from "../Icons/Menus/application.svg";
import contactIcon  from "../Icons/Account/ContactUs.svg";
import HomeIcon  from "../Icons/Account/Home.svg";
import IntroIcon  from "../Icons/Account/Intro.svg";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "react-i18next";
import Nav1  from "../Icons/Account/Nav1.png";
import Nav2  from "../Icons/Account/Nav2.png";
import Nav3  from "../Icons/Account/Nav3.png";
import Nav4  from "../Icons/Account/Nav4.png";
import Nav5  from "../Icons/Account/Nav5.png";
import Nav6  from "../Icons/Account/Nav6.png";
import Nav7  from "../Icons/Account/Nav7.png";
import { changePath } from "../Redux/Feature/LanguageSlice";

export default function Menus() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()

  const language = useSelector((state) => state.language.language)
  
  const hostelData = useSelector((state) => state.CommonData.HostelData)
  const {t} = useTranslation()

 
  useEffect(() => {
      dispatch(changePath(location.pathname))
  }, [location])

  const [menus, setMenus] = useState([
    {
      id: 1,
      nav_bar_name: "Home",
      isdrobdown: 0,
      uri_link: "/",
      icon: Nav1,
    },
    {
      id: 2,
      nav_bar_name: "About Us",
      isdrobdown: 0,
      uri_link: "/intro",
      icon: Nav2,
    },
    {
      id: 3,
      nav_bar_name: "Student Hostel",
      isdrobdown: 1,
      uri_link: "/application",
      icon: Nav3,
      submenu: [
        
        {
          _id: 1,
          name: { en: 'Vinga Hall Application', 'zh-tw': '宿舍申請', zh: '宿舍申請' },
          link : "/application"
        },
        // {
        //   _id: 1,
        //   name: { en: 'Rent Payment', 'zh-tw': '線上繳費', zh: '線上繳費' },
        //   link : "/rent-payment"
        // },
        // {
        //   _id: 1,
        //   name: { en: 'Repair Application', 'zh-tw': '報修申請', zh: '報修申請' },
        //   link : "/repair-application"
        // },
      ],
    },
    {
      id: 4,
      nav_bar_name: "Services",
      isdrobdown: 1,
      uri_link: "/services",
      icon: Nav4,
      submenu: [
        // { id: 41, name: "Web Development", link: "/services/web" },
        // { id: 42, name: "App Development", link: "/services/app" },
        // { id: 43, name: "SEO Optimization", link: "/services/seo" },
      ],
    },
    {
      id: 5,
      nav_bar_name: "News",
      isdrobdown: 0,
      uri_link: "/news",
      icon: Nav5,
    },
    {
      id: 6,
      nav_bar_name: "Living@Singapore",
      isdrobdown: 1,
      uri_link: "/visitor",
      icon: Nav6,
      submenu: [
        {
          _id: 1,
          name: { en: 'Dentist Appointment', 'zh-tw': '牙醫預約', zh: '牙醫預約' },
          link : '/dental-clinic'
        },
      ],
    },
    {
      id: 7,
      nav_bar_name: "Contact Us",
      isdrobdown: 0,
      uri_link: "/contact-us",
      icon: Nav7,
    },

  ])

  
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const handleDropdownOpen = (event, itemId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpenDropdownId(itemId);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
    setOpenDropdownId(null);
  };

  const fetchServiceDatas = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}get-all-common-services`)
        
        console.log(response)
        
        if(response.status === 200){
          const fetchedServices = response?.data?.data || [];

          setMenus((prevMenus) =>
            prevMenus.map((menu) =>
              menu.id === 4 // Target the "Services" menu
            ? {
                ...menu,
                submenu: fetchedServices.map((service) => ({
                  id: service._id,
                  name: service?.title,
                  link: `/services/${service._id}`,
                })),
              }
            : menu
        )
      );
        }
      } catch (error) {
        console.log(error)
      }
  }

  useEffect(() => {
    fetchServiceDatas()
  }, [])

  useEffect(() => {
    setMenus((prevMenus) =>
      prevMenus.map((menu) => {
        if (menu.id === 3) {
          const filteredSubmenu = menu.submenu?.filter(
            (item) => !item.link?.startsWith('/hostelreview/')
          );
  
          const newHostelSubmenu = hostelData.map((service) => ({
            id: service.id,
            name: service?.title,
            link: `/hostelreview/${service.id}`,
          }));
  
          return {
            ...menu,
            submenu: [...newHostelSubmenu ,...filteredSubmenu ],
          };
        }
        return menu;
      })
    );
  }, [hostelData]);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };



  const [openDropdown, setOpenDropdown] = useState(null); // To track which dropdown is open

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  const isActive = location.pathname

  useEffect(() => {
    let value = 'Home'
    if(isActive == '/'){
        value = 'Home'
    } else if (isActive == '/intro'){
        value = 'Intro'
    }else if (isActive == '/application'){
      value = 'Application'
    }else if(isActive == '/services'){
      value = 'Services'
    }else if(isActive == '/news'){
      value = 'News'
    }else if(isActive == '/visitor'){
      value = 'Visitor'
    }else if(isActive == '/links'){
      value = 'Links'
    }else if(isActive.startsWith('/news/')){
      value = 'News'
    }else if(isActive.startsWith('/hostelreview/')){
      value = 'Hostel Review'
    }
    DocumentTitleChange(value)
  },[isActive])

  const renderMenuItems = () => (
    <>
      {menus?.map((item, index) => {
        const isActive = location.pathname === item?.uri_link;
        return (
          <Box
            key={index}
            onClick={() => {
              if (!item.submenu) {
                navigate(item?.uri_link);
                setDrawerOpen(false);
              }
            }}
            onMouseEnter={() => item.submenu && toggleDropdown(item.id)}
            onMouseLeave={() => item.submenu && toggleDropdown(null)}
            mt="20px"
            pt={3}
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              width: { lg: 120, md: 80, sm: 60 },
              height: "100px",
              borderBottom: isActive ? "3px solid white" : "none",
              "&:hover": {
                borderBottom: "3px solid white",
                backgroundColor: "#23a1a19c",
                transition: "0.2s",
              },
              cursor: "pointer",
            }}
          >
            <Box display="flex" justifyContent="center">
              <Box component="img" sx={{ width: "36px", height: "36px" }} src={item?.icon}></Box>
            </Box>
            <Typography textAlign="center" mt="10px" variant="h9_3" color="white">
              {t(item?.nav_bar_name)}
            </Typography>

            {/* Dropdown menu */}
            {item.submenu && openDropdown === item.id && (
              <Box
                sx={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "200px",
                  maxHeight : '200px',
                  backgroundColor: "white",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                  zIndex: 1000,
                  overflowY : 'auto'
                }}
              >
                {item.submenu.map((sub) => (
                  <Box
                    key={sub.id}
                    onClick={() => {
                      navigate(sub.link)
                      toggleDropdown(null)
                    }}
                    sx={{
                      padding: "10px 15px",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    {sub?.name?.[language]}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        );
      })}
    </>
  );

  return (
    <Box columnGap="20px" sx={{ display: "flex", flexDirection: "row" }}>
      {/* Drawer button for mobile screens */}
      <Box sx={{ display: { xs: "flex", md: "none" } }} alignItems="center">
        <IconButton color="inherit" edge="start" onClick={() => setDrawerOpen(true)}>
          <MenuIcon style={{ color: "white", fontSize: "2rem" }} />
        </IconButton>
      </Box>

      {/* Drawer for mobile screens */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          display: { xs: "block", md: "none" },
          height: "100%",
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: "100%" },
          zIndex : 100000,
        }}
        BackdropProps={{
          style: {
            backdropFilter: "blur(3px)",
          },
        }}
      >
        <Box sx={{ backgroundColor: "#27bac4", p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <LogoIcon style={{ cursor: "pointer" }} onClick={() => navigate("/")} />
          <Button onClick={() => setDrawerOpen(false)}>
            <CloseIcon sx={{ fontSize: "2rem", color: "white" }} />
          </Button>
        </Box>
        <Box sx={{ backgroundColor: "#ffffff", height: "100%" }}>
      {menus?.map((item, index) => {
        const isActive = location.pathname === item?.uri_link;

        return (
          <Box
            key={index}
            onClick={() => {
              
              if(item.id !== 4 && item.id !== 3 && item.id !== 6){
                setDrawerOpen(false);
                navigate(item?.uri_link);
              }
             
            }}
            mt="10px"
            sx={{
              backgroundColor: isActive ? "#e7e6e873" : "",

              margin: "20px",
              padding: "20px",
              borderRadius: "10px",
              display: "flex",
              gap : 3,
              alignItems: "center",
              height: "auto",
              position: "relative",
              flexDirection: { xs: "row", sm: "row" },
              "&:hover": { backgroundColor: "#dddcde", transition: "0.2s" },
              cursor: "pointer",
              
            }}
          >
            <Box
              component="img"
              src={item?.icon}
              sx={{
                backgroundColor: "#009ca3",
                p: 1.4,
                borderRadius: "15px",
                width: { xs: "50px", sm: "auto" },
                height: { xs: "50px", sm: "auto" },
              }}
            />

            <Typography
              sx={{
                fontSize: ".8rem",
                fontWeight: 600,
                letterSpacing: "1.2px",
                ml: { xs: 0, sm: 2 },
                mt: { xs: 1, sm: 0 },
                textAlign: { xs: "center", sm: "left" },
              }}
              color={isActive ? "#009ca3" : "black"}
              onClick={(e) => handleDropdownOpen(e, item.id)}
            >
              {item?.nav_bar_name}
            </Typography>

            {/* Submenu button (for dropdown) */}
            {item.submenu && item.submenu.length > 0 && (
              <Box
              onClick={(e) => handleDropdownOpen(e, item.id)}
                sx={{
                  mt: { xs: 1, sm: 0 },
                  ml: { sm: "auto" },
                  fontSize: "0.9rem",
                  color: "#009ca3",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <KeyboardArrowDownIcon />
              </Box>
            )}

            {/* Material UI Menu Dropdown */}
            <Menu
              style={{zIndex : 100000000000}}
              anchorEl={anchorEl}
              open={openDropdownId === item.id}
              onClose={handleDropdownClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  width: { xs: "100%", sm: "100%" },
                  maxHeight: 250,
                  // zIndex : 100000000000
                },
              }}
            >
              {item.submenu?.map((sub) => (
                <MenuItem
                sx={{
                  // zIndex : 100000,
                }}
                  key={sub.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDropdownClose();
                    navigate(sub.link);
                    setDrawerOpen(false)
                  }}
                >
                  {sub?.name?.[language]}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        );
      })}
    </Box>

      </Drawer>

      {/* Menu for larger screens */}
      <Box sx={{ display: { xs: "none", md: "flex", gap : '5px' }, flexDirection: "row" }}>{renderMenuItems()}</Box>
    </Box>
  );
}

